
export default ({ request }) => ({
  get_captcha() {
    return request({
      url: '/v1/tenant_users/captcha',
      method: 'get',
    })
  },
  // 检查是否需要验证码
  check_captcha_required(mobile) {
    return request({
      url: '/v1/tenant_users/check-captcha-required',
      method: 'post',
      data: { mobile }
    })
  },
  user_login(params) {
    return request({
      url: '/v1/tenant_users/login',
      method: 'post',
      data: params
    })
  },
  update_user(id, params) {
    return request({
      url: `/v1/tenant_users/${id}`,
      method: 'put',
      data: params
    })
  },
  get_platform_users(params) {
    return request({
      url: '/platform/v1/users',
      method: 'get',
      params: params
    })
  }
})
